import styled from 'styled-components'

export const StyledHeaderWithStats = styled.div`
	@media(max-width: 768px){
		margin-top: 30px;
	}
	@media(max-width: 575px){
		& .leftSide, .rightSide{
			flex-basis: 50%;
			max-width: 50%;
		}
	}
`
